import bhku from "@assets/icons/bhku.svg";
import TitleIcon from "@assets/icons/for-you-title-icon.svg";
import moreLinkIcon from "@assets/images/more-link-icon.svg";
import TileBorder from "@assets/images/tile-home-border.svg";
import TileBorderMobile from "@assets/images/tile-home-border-mobile.svg";
import ArticleCard from "@components/Blocks/Card/Article/ArticleCard";
import { MYBH_LINK } from "@config/followTopic";
import Link from "@elements/Typography/Link";
import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";
import { Heading } from "@sphtech/sph-web-ui/elements/Heading";

export type MyBHStoryPackageProps = {
  articles: ProcessedArticleData[];
};

const renderArticleCard = (article: ProcessedArticleData, index: number) => {
  const isFirstArticle = index === 0;
  return (
    <ArticleCard
      key={article.id}
      {...article}
      orientation="horizontal"
      variant={isFirstArticle ? "featured" : "2md"}
      testId={`article-${index}`}
      displayWidth={isFirstArticle ? 488 : 113}
      displayHeight={isFirstArticle ? 366 : 86}
      forNewDesign
    />
  );
};

/**
 * MyBHStoryPackage
 * Description: MyBH story package for home page
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function MyBHStoryPackage({ articles }: MyBHStoryPackageProps) {
  if (articles.length === 0) {
    return <div>No articles available.</div>;
  }
  const firstArticle = articles.at(0);

  return (
    <div
      data-testid="mybh-story-package"
      className="relative my-sm pb-2.5 pt-7 border border-brand-primary border-x-0 border-b-0 border-t-2 max-w-[1197px]"
    >
      <div className="absolute top-0 left-0 w-full h-[73px] bg-gradient-to-b from-lightBlue-50 to-transparent">
        <img
          src={TileBorder}
          alt="border"
          className="hidden md:block"
          width={1197}
          height={73}
        />
        <img src={TileBorderMobile} alt="border" className="md:hidden w-full" />
      </div>

      <div
        data-testid="block-title"
        className="flex gap-2 px-2 py-1 text-sm font-semibold text-neutral-700 leading-[24px] mb-3 z-10 relative"
      >
        <img src={TitleIcon} alt="title-icon" width={20} height={20} />
        <Heading
          Element="h4"
          className="font-primary text-brand-primary"
          testId="heading"
        >
          Untukmu
        </Heading>
      </div>
      <div className="flex flex-col md:flex-row gap-4 md:gap-md">
        <div className="basis-3/6 lg:basis-4/6">
          {firstArticle && renderArticleCard(firstArticle, 0)}
        </div>
        <div className="basis-3/6 lg:basis-2/6 flex flex-col gap-xs">
          {articles.slice(1, 4).map((item, idx) => {
            return renderArticleCard(item, idx + 1);
          })}
        </div>
      </div>

      <div className="flex items-center justify-end text-xxs leading-[150%] text-neutral-700 font-semibold font-primary border-border-strong border-t-[1px] mt-6 pt-3">
        <Link
          destination={`${MYBH_LINK}?ref=mybh-home`}
          className="flex items-center gap-[5px]"
          testId="mybh-link"
        >
          <span>Go to</span>
          <img
            src={bhku}
            width={40}
            className="-ml-0.5 pb-0.5 h-[18px]"
            alt="bhku icon"
          />
          <img src={moreLinkIcon} width={16} height={16} alt="more link icon" />
        </Link>
      </div>
    </div>
  );
}
